import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { apiRequest } from '../reducers/data'
import { BsEyeSlash, BsEye } from "react-icons/bs";

class _SignInContainer extends React.Component {
  static contextTypes = {
    router: () => { },
  }

  constructor(props) {
    super(props)
    this.state = { email: '', password: '', error: '', eula: false, showPassword: false }
  }

  toggleShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }))
  }

  onSubmit = async (e) => {
    e.preventDefault()
    const { json } = await this.props.dispatch(apiRequest(['login'], 'POST', this.state))
    if (json.error) {
      this.setState({ error: json.error })
    } else {
      this.props.dispatch(apiRequest(['me']))
      if (window.bridge) {
        window.bridge.authorizeNotifications()
      }
    }
  }

  render() {
    const { email, password, error, eula, showPassword } = this.state

    return (
      <div
        className="screen sign-in"
        style={{
          background: `url(${require('../images/hex_background.jpg')})`,
          backgroundSize: 'cover',
        }}
      >
        <div>
          <form onSubmit={this.onSubmit}>
            <img className="logo" src={require('../images/logo.png')} alt="logo" />
            {error && <div className="error">{error}</div>}
            <input
              type="email"
              name="email"
              id="email"
              value={email}
              placeholder="Email Address"
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            <div className="password-row">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                id="password"
                value={password}
                placeholder="Password"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
              <span
                type="button"
                className="password-toggle"
                onClick={this.toggleShowPassword}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <BsEyeSlash /> : <BsEye />}
              </span>
            </div>
            <button className="block" type="submit">
              Sign In
            </button>
            <a
              href={`${process.env.REACT_APP_BASE_URL}/forgot`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Forgot password?
            </a>
          </form>
        </div>
      </div>
    )
  }
}

export default connect(() => {
  return {}
})(_SignInContainer)
